import React from 'react';
import {GoogleMap, LoadScript} from '@react-google-maps/api';

export const Mapas = () => {
	const containerStyle = {
		width: '400px',
		height: '400px',
	};

	const center = {
		lat: -3.745,
		lng: -38.523,
	};

	return <></>;
};
/*
            <LoadScript
                googleMapsApiKey=""
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={10}
                >
                    <></>
                </GoogleMap>
            </LoadScript>
*/
